import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-landing',
  templateUrl: './layout-landing.component.html',
  styleUrls: ['./layout-landing.component.scss']
})
export class LayoutLandingComponent implements OnInit {

  sidebar =  false;

  constructor() { }

  ngOnInit(): void {
  }

}
